import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  mapProps,
  withProps,
} from 'recompose';
import { connect } from 'react-redux';

import Record from './record';
import * as selectors from './selectors';
import withPagination from '../../components/PaginatedItems/withPagination';
import { Endpoints } from '../../lib/LeanLinkService';

function mapStateToProps(state, { invoiceDeliveryTypesIds }) {
  return {
    invoiceDeliveryTypes: selectors.invoiceDeliveryTypesByIds(state, invoiceDeliveryTypesIds),
  };
}

const withInvoiceDeliveryTypes = compose(
  setPropTypes({
    invoiceDeliveryTypesIds: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  }),
  connect,
  setPropTypes({
    invoiceDeliveryTypes: PropTypes.arrayOf(PropTypes.instanceOf(Record)),
  }),
)(mapStateToProps);

export default (shouldFetchData = false) => {
  if (shouldFetchData) {
    return compose(
      withProps({
        url: Endpoints.invoiceDeliveryTypes(),
      }),
      withPagination(),
      mapProps(({ ids, ...props }) => ({
        ...props,
        invoiceDeliveryTypesIds: ids,
      })),
      withInvoiceDeliveryTypes,
    );
  }

  return withInvoiceDeliveryTypes;
};
